module.exports = "/_next/static/images/stripe1-887ac1f95e0f59f2aeca4bc2736db59d.png";